/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Fleet_Auto_HintInputs */

const en_dispatch_fleet_auto_hint = /** @type {(inputs: Dispatch_Fleet_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RMF Core arbitrates between capable fleets via bidding.`)
};

const fr_dispatch_fleet_auto_hint = /** @type {(inputs: Dispatch_Fleet_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RMF Core arbitre entre les flottes capables via bidding.`)
};

const ms_sg2_dispatch_fleet_auto_hint = /** @type {(inputs: Dispatch_Fleet_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RMF Core menimbang antara armada yang mampu melalui bidaan.`)
};

/**
* | output |
* | --- |
* | "RMF Core arbitrates between capable fleets via bidding." |
*
* @param {Dispatch_Fleet_Auto_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_fleet_auto_hint = /** @type {((inputs?: Dispatch_Fleet_Auto_HintInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Fleet_Auto_HintInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_fleet_auto_hint(inputs)
	if (locale === "fr") return fr_dispatch_fleet_auto_hint(inputs)
	return ms_sg2_dispatch_fleet_auto_hint(inputs)
});